import React, {  Component } from 'react';
import { connect } from 'react-redux';
import {browserHistory} from 'react-router';
import {
    getProductSpecs,
    getPricesforAccessories,
    addToList,
    saveToList,
    addToCart,
    saveAvailabilityToCart,
    getPIMItemInfo,
    updateCartOrderPoints,
    } from '../../redux/actions';
import { processPricingResponse } from '../../redux/util';

import _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';

import { DATE_TIME_FORMAT } from '../common/messageConstants';

class addAccessoriesDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            errorMessage:'',
            accessories:[],
            accessoriesAvailability:[],
            accessoriesPrices:[],
            selectedAccessories:[],
            showDialogData: false,
            isSelectAll: true,
            accessoriesItem:[],
        };
        this.getSelectedItemsAndCount = this.getSelectedItemsAndCount.bind(this);
    }

    handleSelect(sku, event){
        this.state.accessories.map((item, index) => {
            if (index === sku) {
                item.selected = event.target.checked
            }
            return null;
        })
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog("AddAccessoriesDialog", false);
    }

    componentDidMount() {
        // window.scrollTo(0, 0);
        let sku = this.props.accessoriesSku,
			path = window.location.href,
			accountNum = this.props.state.user.selectedAccount.ACCOUNTNUMBER,
			self = this;
        self.props.getProductSpecs(`skus=${sku}`, (resp) => {
            let skuList = [];
            if(resp.status && resp.responseObject && resp.responseObject.length) {
				resp.responseObject = resp.responseObject[0];
        		let productSpecsData = self.props.manipulateProductSpecsData(resp);
				const { isPricingAccess } = self.props;
                let accessories = productSpecsData.responseObject.relationships ? productSpecsData.responseObject.relationships : null;
                let accessoriesKit =  _.find(accessories, ["name", "Accessories Kit_"]);
                let optionalCharges = (productSpecsData.responseObject.optionalCharge !== null && productSpecsData.responseObject.optionalCharge !== undefined)? productSpecsData.responseObject.optionalCharge.split('|').map(sku => ({ sku })) : undefined;
                accessories = _.find(accessories, ["name", "Accessories_"]);
                if(accessories !== undefined ) {
                    accessories.items = accessoriesKit !== undefined ? _.unionBy(accessories.items,accessoriesKit.items,"sku") : accessories.items;
                    accessories.items = optionalCharges !== undefined? _.unionBy(accessories.items, optionalCharges, 'sku') : accessories.items;
                } else if (optionalCharges !== undefined) {
                    accessories = {};
                    accessories.items = optionalCharges;
                }
                let itemForApi=``;
                if(accessories && accessories.items) {    
					accessories = accessories.items;
	                accessories.map((item, index)=>{
                        itemForApi = itemForApi + item.sku + ` `;
	                    return skuList.push({'sku': item.sku})
	                });
                    self.props.getProductSpecs(`skus=${itemForApi}`, (resp) => {
                        this.setState({
                            accessoriesItem: accessories ? resp.responseObject : ''
                        })
                         if(resp && resp.responseObject){
                            resp.responseObject.map((item)=>{
                              if(item !== null & item!== undefined) {
                                accessories.find((accessory)=>{
                                    if( accessory.sku === item.sku){
                                      accessory.imagePath = item.imagePath;
                                      accessory.description = item.description;
                                    }
                                    });
                              }
                            });
                         }
                    });
					if(isPricingAccess) {
						const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
		                var payload = [];
		                skuList.map((item,index) => {
		                    return payload.push(item.sku);
		                });
						self.props.getPricesforAccessories({
		                    account_number: self.props.state.user.selectedAccount.ACCOUNTNUMBER,
		                    pricing_effective_date: pricingEffectiveDate,
		                    sa_number: self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER.toString(),
		                    item_numbers: payload
		                }, response => {
							response = processPricingResponse(response);
		                    var showAccessoriesArray = [];
		                    if(response.responseObject && response.responseObject.items && response.responseObject.items.length > 0) {
		                        response.responseObject.items.map((item, index) => {
		                            if (item.records && item.records.length && (item.records[0].adjusted_unit_price || item.records[0].unit_price)){
		                                showAccessoriesArray.push({'item': item.item_number})
		                                self.setState({
		                                    accessoriesPrices: _.sortBy(response.responseObject.items, ['item_number'])
		                                })
		                            }
		                            return null;
		                        });
		                        var accessoriesPush = []
		                        accessories && accessories.length > 0 && accessories.map((item, index) =>{
		                            if (showAccessoriesArray.findIndex(x => x.item === item.sku) >= 0)
		                                accessoriesPush.push(accessories[index]);
		                            return null
		                        })
		                        if(accessoriesPush && accessoriesPush.length > 0) {
		                            var skuList = []
		                            accessoriesPush.map((item, index)=>{
		                                return skuList.push({'sku': item.sku})
		                            });
		                            if(skuList && skuList.length > 0) {
										const data = JSON.parse(self.props.state.user.selectedAddress);
										const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
										zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
											if(resp && resp.agentid) {
				                                self.props.checkAvailabilityGeneric(skuList,`accountNumber=${accountNum}&zipCode=${this.props.getZipCode()}&legacyCustCode=${this.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, '', true, (response)=>{
													if(response.status && response.responseObject.length > 0) {
                                                        const {accessoriesPrices} = self.state;
                                                        accessoriesPush = accessoriesPush.map((item)=>{
                                                        const priceDetails=accessoriesPrices.find((accesoriesPrice)=>accesoriesPrice.item_number==item.sku);
                                                        if(priceDetails){
                                                        return({...item,price:priceDetails.records && priceDetails.records.length && (priceDetails.records[0].adjusted_unit_price || priceDetails.records[0].unit_price)})
                                                         }else {
                                                           return { ...item, price: null };
                                                            };
                                                         }).filter(item => item.price !== null)
                                                         .sort((a,b)=>b.price - a.price);
                                                        const availableSku = _.intersectionBy(accessoriesPush, response.responseObject, 'sku');
                                                        const mergedElements = availableSku.map(item1 => {
                                                            const item2 = _.find(response.responseObject, { sku: item1.sku });
                                                            return _.mergeWith({}, item1, item2, (objValue, srcValue) => {
                                                              return objValue == null ? srcValue : objValue;
                                                            });
                                                          });
														self.setState({
					                                        accessoriesAvailability: response.responseObject,
					                                        accessories:mergedElements,
															showDialog: self.props.showDialog
					                                    })
													} else {
														self.setState({
						                                    errorMessage:'Error occured while checking availability of accessories.',
						                                    showDialog: self.props.showDialog
						                                });
													}
				                                });
											}
										});
		                            } else {
		                                self.setState({
		                                    errorMessage:'No accessories available for this product',
		                                    showDialog: self.props.showDialog
		                                });
		                            }
		                        } else {
		                            self.setState({
		                                errorMessage:'No accessories available for this product',
		                                showDialog: self.props.showDialog
		                            });
		                        }
		                    } else {
		                        self.setState({
		                            errorMessage:'No accessories available for this product',
		                            showDialog: self.props.showDialog
		                        });
		                    }
		                });
					} else {
						const data = JSON.parse(self.props.state.user.selectedAddress);
						const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
							if(resp && resp.agentid) {
								self.props.checkAvailabilityGeneric(skuList,`accountNumber=${accountNum}&zipCode=${this.props.getZipCode()}&legacyCustCode=${this.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, '', true, (response)=>{
									if(response.status) {
										self.setState({
											accessoriesAvailability:response.responseObject,
											accessories:accessories,
											showDialog: self.props.showDialog
										})
									} else {
										self.setState({
											errorMessage:'Error occured while checking availability of accessories.',
											showDialog: self.props.showDialog
										});
									}
								});
							}
						});
					}
				} else {
					self.setState({
						errorMessage:'No accessories available for this product',
						showDialog: self.props.showDialog
					});
				}
            } else {
                self.setState({
                    errorMessage:'No accessories available for this product',
                    showDialog: self.props.showDialog
                });
            }
        });

        self.setState({
			productSku: sku,
			page: path.indexOf("cart") > 0 ? "cart" : (path.indexOf("list") > 0 ? "list" : 'package')
        });
    }

    getSelectedItemsAndCount() {
        const self = this;
        let selectedCount = 0;
        const selectedItems = [];
        self.state.accessories.forEach((item, index) => {
            if (item.selected && item.selected === true) {
                selectedCount += 1;
                selectedItems.push(item);
            }
        });
        if (selectedCount === 0) {
            self.setState({
                errorMessage: "Please select at least one item and try again."
            });
        }
        return {
            selectedCount,
            selectedItems
        };
    }

    handleAddToList(event){
        event.preventDefault();
		const self = this;
        const { selectedCount, selectedItems } = self.getSelectedItemsAndCount();
        if(selectedCount){
			const { selectedPriceSource } = this.props.state.user;
		    let oldList =  this.props.state.list.list.responseObject.wishlistItems
                ? this.props.state.list.list.responseObject.wishlistItems
                : [], skuList = []
            skuList = oldList.map((item,index)=>{
                return item.item
            });
            selectedItems.map((item,index)=>{
                if(skuList.indexOf(item.sku) < 0) {
                    oldList.push({
                        itemType: 'A',
                        item: item.sku,
                        quantity: "1",
                        parentItem: this.props.accessoriesSku,
                        itemDescription: item.description,
						agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
						createdDate: moment().format(DATE_TIME_FORMAT),
						updatedDate: moment().format(DATE_TIME_FORMAT),
                        imagePath:item.imagePath
                    });
				}
                return null
            });
            this.props.addToList({
                accountNumber: this.props.state.user.selectedAccount.ACCOUNTNUMBER,
                createdDate: moment().format('MM/DD/YYYY'),
                updatedDate: moment().format('MM/DD/YYYY'),
                userId: this.props.state.user.userDetails.sso,
                wishlistItems: oldList
            }, response => {
                if(response.status) {
                    if(response.responseObject) {
                        const skuList = []
                        response.responseObject && response.responseObject.wishlistItems && response.responseObject.wishlistItems.length > 0 && response.responseObject.wishlistItems.map((item, index) => {
                            return skuList.push({"sku":item.item})
                        });
						const data = JSON.parse(self.props.state.user.selectedAddress);
						const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
							if(resp && resp.agentid) {
		                        skuList.length >0 && self.props.checkAvailabilityGeneric(skuList,`accountNumber=${this.props.state.user.selectedAccount.ACCOUNTNUMBER}&zipCode=${this.props.getZipCode()}&legacyCustCode=${this.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, 'list', true, (response) => {
		                        });
							}
						});
                        self.props.saveToList(response);
                    }
                } else {
                    browserHistory.push('/error');
                }
            });
            this.setState({
                showDialog: false
            });
        }
    }

    handleAddToPackage(event) {
        event.preventDefault();
		const self = this;
        const { selectedCount, selectedItems } = self.getSelectedItemsAndCount();
        if(selectedCount) {
            const accessories = [];
			const { selectedPriceSource } = this.props.state.user;
            const { accessoriesPrices } = self.state;
            selectedItems.forEach((item, index)=>{
                const price = _.find(accessoriesPrices, {item_number: item.sku});
                accessories.push({
                    itemType: 'A',
                    item: item.sku,
                    quantity: "1",
                    price: (price.records[0].adjusted_unit_price || price.records[0].unit_price),
                    parentItem: this.props.accessoriesSku,
                    itemDescription: item.description,
					agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
					createdDate: moment().format(DATE_TIME_FORMAT),
	                updatedDate: moment().format(DATE_TIME_FORMAT),
                });
            });
            self.props.handleAddAccessories(accessories);
            self.setState({
                showDialog: false
            });
        }
    }

    handleAddToCart(event){
        event.preventDefault();
		const self = this;
        const { selectedCount, selectedItems } = self.getSelectedItemsAndCount();
        if(selectedCount) {
			const { selectedPriceSource } = this.props.state.user;
		    let oldCart =  self.props.state.cart.cart.responseObject.cartItems
                ? self.props.state.cart.cart.responseObject.cartItems
                : [], skuList = []
            skuList = oldCart.map((item,index)=>{
                return item.item
            });
            let cartPimData = self.props.state.cart.cartPimData;
            const products = [];
            const skuListForPim = [];
            selectedItems.forEach((item,index)=>{
                if(skuList.indexOf(item.sku) < 0) {
                    oldCart.push({
                        itemType: 'A',
                        item: item.sku,
                        quantity: "1",
                        parentItem: this.props.accessoriesSku,
                        itemDescription: item.description,
						agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
						createdDate: moment().format(DATE_TIME_FORMAT),
		                updatedDate: moment().format(DATE_TIME_FORMAT),
                        imagePath:item.imagePath
                    });
                    let price = _.find(self.state.accessoriesPrices, {item_number: item.sku});
                    price = price ? (price.records[0].adjusted_unit_price || price.records[0].unit_price) : undefined;
                    const availability = _.find(this.state.accessoriesAvailability, {sku:item.sku})
                    products.push({
                        name: item.description,
                        id: item.sku,
                        price: price ? self.props.formatMoney(price, 0, ".", ",", false, "") : undefined,
                        brand: undefined,
                        category: undefined,
                        variant: undefined,
                        quantity: "1",
                        dimension70: availability.availableQty === '0' ? 'yes' : 'no'
                    });
                }
                if (!(cartPimData && cartPimData.pimData && cartPimData.pimData.some(cartPimItem => cartPimItem.item_number === item.sku)) && !skuListForPim.includes(item.sku)) {
                    skuListForPim.push(item.sku);
                }
            });
            let cartCount = 0;
            oldCart.forEach((itm, index) => {
				cartCount += parseInt(itm.quantity, 10);
    		});
            self.props.fireGTMTag('Add to Cart', {
    			addToCartLocation: 'cart',
    			cartQuantity: cartCount,
    			ecommerce: {
    				currencyCode: 'USD',
    				add: {
    					actionField: {
    						list: undefined,
    						position: undefined,
    					},
    					products
    				}
    			}
    		});
			const { selectedAccount, userDetails } = self.props.state.user;
            self.props.addToCart({
                accountNumber: selectedAccount.ACCOUNTNUMBER,
                createdDate: moment().format('MM/DD/YYYY'),
                updatedDate: moment().format('MM/DD/YYYY'),
                userId: userDetails.sso,
                cartItems: oldCart
            }, response => {
                if(response.status) {
                    if(response.responseObject) {
                        const skuList = []
                        response.responseObject && response.responseObject.cartItems && response.responseObject.cartItems.length > 0 && response.responseObject.cartItems.map((item, index) => {
                            skuList.push({
                                itemNumber: item.item,
                                identifier: index + 1,
                                qty: +item.quantity || 1,
                                shipMethod: 'ADC Truckload',
                                arrivalSetName: '',
                                itemType: '',
                                demandClass : self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
                                overrideFlag: 'N',
                                quantityUOM: 'EA',
                                agreementNumber: item.agreementNumber,
                            })
                        });
						const data = JSON.parse(self.props.state.user.selectedAddress);
						const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
							if(resp && resp.agentid) {
                                if (skuList.length) {
                                    const payload = {
                                        accountNumber: selectedAccount.ACCOUNTNUMBER,
                                        warehouseCode: resp.agentid,
                                        customerSiteId: data.addressId ? data.addressId :data.SITE_USE_ID,
                                        requestedDeliveryDate: moment().format('MM/DD/YYYY'),
                                        orderSource: '',
                                        zipCode: zipCode,
                                        state: data.STATE,
                                        country: data.COUNTRY,
                                        tradingPartnerId:'',
                                        dateType:'SHIP',
                                        items: skuList,
                                    };
                                    self.props.checkAvailabilityForOrder(payload, orderAvailability => {
                                        if (orderAvailability) {
                                            self.props.saveAvailabilityToCart({responseObject: orderAvailability.map(orderAvailabilityItem => this.props.formatOrderAvailabilityData(orderAvailabilityItem))});
                                        }
                                    });
                                }
							}
						});
                        if (skuListForPim.length) {
                            self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", pimResponse => {
                                if (pimResponse.status && pimResponse.responseObject) {
                                    cartPimData = cartPimData ? { ...cartPimData, pimData: (cartPimData.pimData || []).concat(pimResponse.responseObject) } : { pimData: pimResponse.responseObject };
                                    self.props.updateCartOrderPoints(cartPimData);
                                }
                            })
                        }
						if(self.props.isPricingAccess && skuList.length > 0) {
							self.props.makeParallelCallsForCartPrices(response.responseObject.cartItems, true, true, 'cart', null, null);
						}
                    }
                } else {
                    browserHistory.push('/error');
                }
            });
            this.setState({
                showDialog: false
            });
        }
    }

    handleSelectAll(event) {
        event.preventDefault();
        this.state.accessories.map((item, index) => {
            item.selected = this.state.isSelectAll
            return null;
        })
        this.setState({
            isSelectAll: !this.state.isSelectAll
        })
    }

    render() {
		const { isPricingAccess } = this.props;
        return (
            <div>
	            <div className="overlayDialog " id="confirmApproveRequestDialog" style={{visibility: (this.state.showDialog===true?'visible':'hidden')}}>
	                <div className="blackoutLayer"></div>
	                    <div className="overlayDialogWindow" style={{width: '41em'}}>
	                    <a className="closeButton" onClick={this.closeDialog.bind(this)} href="">×</a>
	                    <h2 className="title">Add Accessories</h2>
	                    <form className="addAccessoriesForm" name="addAccessoriesForm" id="addAccessoriesForm" action="">
	                        {this.props.accessoriesSku && this.state.accessories && this.state.accessories.length > 0?<p>Accessories for: <strong>{this.props.accessoriesSku}</strong></p>:null}
	                        {this.state.errorMessage?<p className="red">{this.state.errorMessage} : <strong>{this.props.accessoriesSku}</strong></p>:null}
	                        {this.state.accessories && this.state.accessories.length?
	                            <div style={{height: 300, overflow: 'auto'}}>
	                                <table className="addAccessoriesFormTable dataTableType2">
	                                    <thead>
	                                        <tr>
	                                            <th>Product</th>
	                                            <th>Availability</th>
	                                            {isPricingAccess && <th>Price <span className="unbold">(Each)</span></th>}
	                                            <th className="select">
	                                                <a className="selectAllCheckboxesLink" onClick={this.handleSelectAll.bind(this)} name="selectedProduct" href="">{
	                                                        this.state.isSelectAll
	                                                            ? "Select"
	                                                            : "Deselect"
	                                                    }
	                                                    All</a>
	                                            </th>
	                                        </tr>
	                                    </thead>
	                                    <tbody>
	                                        {this.state.accessories && this.state.accessories.length > 0 && 
                                                this.state.accessories
                                                .map((item) => {
                                                    const availability = _.find(this.state.accessoriesAvailability, { sku: item.sku });
                                                    if (!availability) return null;
                                                    
                                                    const priceInfo = isPricingAccess && _.find(this.state.accessoriesPrices, { item_number: item.sku });
                                                    if (isPricingAccess && (!priceInfo || (priceInfo && priceInfo.records[0] && priceInfo.records[0].orderable !== "Y"))) return null;
                                                    
                                                    const price = priceInfo ? (priceInfo.records[0].adjusted_unit_price || priceInfo.records[0].unit_price) : null;
                                                    
                                                    return { ...item, price, availability };
                                                })
                                                .filter(item => item.price !== null)
                                                .sort((a, b) => b.price - a.price)  // Sorting the array by price in descending order
                                                .map((item, index) => (
                                                    <tr key={index}>
                                                    <td key={index + 4}>
                                                        <div className="sku">{item.sku}</div>
                                                        <div>{item.description}</div>
                                                    </td>
                                                    <td key={index + 1} style={{ textAlign: 'center' }}>
                                                        {item.availability.availableQty}
                                                    </td>
                                                    {isPricingAccess && 
                                                        <td key={index + 2}>
                                                        {item.price}
                                                        </td>}
                                                    <td key={index + 3} style={{ textAlign: 'center' }}>
                                                        <input 
                                                        checked={item.selected} 
                                                        type="checkbox" 
                                                        name={`addAccessory_${item.sku}`} 
                                                        onClick={this.handleSelect.bind(this, index)} 
                                                        />
                                                    </td>
                                                    </tr>
                                                ))
                                            }
	                                    </tbody>
	                                </table>
	                            </div>
	                        :null}
	                    {this.state.accessories?
	                    <div className="noButtonContainer">
	                        <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
	                    </div>:null}
	                    {this.state.accessories && this.state.accessories.length > 0
    	                    ? <div className="yesButtonContainer">
    	                        <input
                                    className="yesButton greenButton"
                                    type="submit"
                                    onClick={
                                        this.state.page==="cart"
                                            ? this.handleAddToCart.bind(this)
                                            : (
                                                this.state.page==="list"
                                                    ? this.handleAddToList.bind(this)
                                                    : this.handleAddToPackage.bind(this)
                                            )
                                    }
                                    defaultValue={
                                        this.state.page==="cart"
                                        ? "Add to Cart"
                                        : (
                                            this.state.page==="list"
                                                ? "Add to List"
                                                : "Add to Package"
                                        )
                                    }
                                />
    	                    </div>
                            : null
                        }
	                </form>	{/* / .addAccessoriesForm#addAccessoriesForm */}
	                </div>
	            </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

const mapDispatchToProps = (dispatch) => ({
    getProductSpecs: (payload, callback) => dispatch(getProductSpecs(payload, callback)),
    getPricesforAccessories: (payload, callback) => dispatch(getPricesforAccessories(payload, callback)),
    addToList: (payload, callback) => dispatch(addToList(payload, callback)),
    saveToList: (payload) => dispatch(saveToList(payload)),
    addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
    saveAvailabilityToCart: data => dispatch(saveAvailabilityToCart(data)),
    getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
    updateCartOrderPoints: (data) => dispatch(updateCartOrderPoints(data)),
});

addAccessoriesDialog = connect(mapStateToProps, mapDispatchToProps)(addAccessoriesDialog);
export default addAccessoriesDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addAccessoriesDialog.js